// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_scsms","sellingPoints":"sellingPoints_yfKbV"};